import queryString from "query-string";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import actions from "./ducks/actions";
import operations from "./ducks/operations";

const LoginContainer = (props) => {
    const navigate = useNavigate();
    useEffect(() => {
        const params = queryString.parse(window.location.search);
        const code = params.code;
        if (code) {
            props.login(code, navigate);
        }
    }, []);
    const params = queryString.parse(window.location.search);
    const code = params.code;
    return <div>{!code && "Invalid Login"}</div>;
};

const mapStateToProps = (state) => {
    return {
        valid: state.authReducer.validFormValues,
        snackbarOpen: state.authReducer.snackbarOpen,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleChangeAndValidate: (event) => {
            dispatch(operations.handleChangeAndValidate(event.target.id, event.target.value));
        },
        hideSnackbar: () => {
            dispatch(operations.hideSnackbar());
        },
        login: async (code, navigate) => {
            const mainPage = await dispatch(operations.login(code));
            navigate(mainPage);
            dispatch(actions.toggleLoggedIn());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
